let baseUrl = ""; //这里是一个默认的url，可以没有
switch (process.env.NODE_ENV) {
  case "development":
    baseUrl =
      // "http://easymock.dev.e6gpshk.com:30081/mock/5c32f3a5d43bcd0021ddbd70/api/"; //这里是本地的请求url
    "/monitor-api/"; //这里是本地的请求url
    break;
  case "production":
    baseUrl = "monitor-api"; //生产环境url
    break;
}

export default baseUrl;



// WEBPACK FOOTER //
// ./src/e6GetBaseUrl.js